import { useState } from 'react';
import useMaintenance from '../../../../../hooks/maintenance/useMaintenance';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';
import ListCompare from './ListCompare';
import { isEmpty } from 'lodash';
import { Checkbox, FormControlLabel } from '@mui/material';

const SyncDialog = ({ show, onClose, module, type, userType = 'Students' }) => {
  const types = ['users', 'classes', 'disable-users', 'disable-classes', 'subjects'];
  const userTypes = ['Students', 'Parents', 'Teachers'];
  const { syncModule, syncDisabledModule } = useMaintenance();
  const [errors, setInputErrors] = useState({});
  const [loading, toggleLoading] = useState(false);
  const [loadingList, toggleLoadingList] = useState(false);
  const [updateYearLevels, setUpdateYearLevels] = useState(false);
  const [updateSubject, setUpdateSubject] = useState(false);

  const onSave = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    if (type === 'users' && !userTypes.includes(userType)) {
      setInputErrors({ userType: 'Invalid user type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false, message: 'Error' };
      if (['users', 'classes', 'subjects'].includes(type)) {
        result = await syncModule(module, { userType, updateYearLevels, updateSubject });
      }
      if (['disable-users', 'disable-classes'].includes(type)) {
        result = await syncDisabledModule(module, { userType });
      }

      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
      }
    } finally {
      toggleLoading(false);
    }
  };

  const title = ['users', 'classes', 'subjects'].includes(type) ? 'sync' : 'disable';
  return (
    <DialogConfirmCancel
      id={`${type}-sync`}
      open={show}
      title={`${title} ${module} list`}
      onCancel={onClose}
      onConfirm={types.includes(type) && userTypes.includes(userType) ? onSave : undefined}
      maxWidth={['disable-users', 'disable-classes'].includes(type) ? 'xs' : 'lg'}
      loading={loading}
      disabledConfirm={loadingList ? true : isEmpty(errors) ? false : true}
    >
      {types.includes(type) ? (
        <div className='flex flex-col gap-4'>
          <div className='flex flex justify-between items-center gap-2'>
            <Typography className='col-span-full'>
              Are you sure you want to <b>{title}</b> list <b>{module}</b>?
            </Typography>
            {['classes'].includes(type) && (
              <div>
                <FormControlLabel
                  id='update-year-levels'
                  disabled={loadingList || loading}
                  control={
                    <Checkbox
                      checked={updateYearLevels}
                      onChange={(e) => setUpdateYearLevels(e.target.checked)}
                    />
                  }
                  label='Update class year levels during sync'
                />
                <FormControlLabel
                  id='update-subject'
                  disabled={loadingList || loading}
                  control={
                    <Checkbox
                      checked={updateSubject}
                      onChange={(e) => setUpdateSubject(e.target.checked)}
                    />
                  }
                  label='Update class subjects during sync'
                />
              </div>
            )}
          </div>

          {['users', 'classes', 'subjects'].includes(type) && (
            <ListCompare
              module={module}
              userType={userType}
              toggleLoadingList={toggleLoadingList}
              loadingList={loadingList}
              updateYearLevels={updateYearLevels}
              updateSubject={updateSubject}
              setError={(message) => setInputErrors({ message })}
            />
          )}
        </div>
      ) : (
        <Alert severity='error'>Invalid module</Alert>
      )}
      {errors && errors.message && (
        <Alert severity='error' className='mt-2'>
          {errors.message}
        </Alert>
      )}
    </DialogConfirmCancel>
  );
};

export default SyncDialog;
